import React from 'react';
import { Helmet } from 'react-helmet-async';

interface MetaTagsProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogType?: 'website' | 'product' | 'article';
  ogImage?: string;
  noIndex?: boolean;
  jsonLd?: Record<string, any> | Record<string, any>[];
}

const MetaTags = ({ 
  title, 
  description, 
  keywords, 
  canonical,
  ogType = 'website',
  ogImage = 'https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/hero-image.webp',
  noIndex = false,
  jsonLd
}: MetaTagsProps) => {
  const fullTitle = title.includes('SUMSAE') ? title : `${title} | SUMSAE`;
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';

  const renderJsonLd = () => {
    if (!jsonLd) return null;
    const items = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
    return items.map((item, index) => (
      <script key={index} type="application/ld+json">
        {JSON.stringify(item)}
      </script>
    ));
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="SUMSAE" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={currentUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Additional SEO meta tags */}
      <meta name="author" content="SUMSAE" />
      <meta name="theme-color" content="#8B4513" />

      {renderJsonLd()}
    </Helmet>
  );
};

export default MetaTags;